module.exports = __webpack_public_path__ + "img/alerts-2.b79e6af8.gif";